import React from "react";
import "./FormFieldsStyle.css";
//import asteriskImg from "../../images/img/asterisk.png"

const Dropdown = (props) => {
  const dataList = props.item && props.item.text_data;
  console.log("dropdownprops", props, dataList);

  const handleSelect = (e) => {
    console.log("selectedvalue", e.target.value);
    if (e.target.value) {
      props?.inputValue?.current?.removeAttribute("disabled");
    } else {
      props?.inputValue?.current?.setAttribute("disabled", true);
    }

    localStorage.setItem(
      "inputValue",
      JSON.stringify({ key1: e.target.value })
    );
  };

  return (
    <div className="form-group">
      <label className="sel" style={{ fontSize: "16px", color: "#444444" }}>
        <span className="asterisk-icon">{/* <img src={} alt="" /> */}</span>
      </label>
      <select
        className="form-control"
        onChange={handleSelect}
        style={{ color: "#444444" }}
        disabled={props.disable}
        required
      >
        <option selected style={{ display: "none" }}>
          Select
        </option>
        {dataList.data &&
          dataList.data.map((i) => (
            <option
              // value={JSON.stringify({data:[{name:i.name,value:i.value}]})}
              value={i.value}
            >
              {i.name}
            </option>
          ))}
      </select>
      <span className="validate">&nbsp;</span>
    </div>
  );
};

export default Dropdown;
